import { useState } from "react";
import StyleWrapper, {
    StyleContentWrapper,
    StyleTitlePage,
    StyleRegulamentoWrapper,
    StyleRegulamentoContent
} from "./style";

export default ({setIsModalOpen}) => {
    return (
        <>
            <StyleWrapper>
                <StyleContentWrapper>
                    <StyleTitlePage>Regulamento</StyleTitlePage>
                    <StyleRegulamentoWrapper>
                        <StyleRegulamentoContent>
                            <div>
                                <strong>
                                    REGULAMENTO/PLANO DE OPERA&Ccedil;&Atilde;O
                                    DA PROMO&Ccedil;&Atilde;O BEST DRIVE
                                    PREMIADO
                                </strong>
                                <p>
                                    <strong>
                                        CERTIFICADO DE AUTORIZA&Ccedil;&Atilde;O
                                        SPA/ME N&ordm; 04.045460/2025
                                    </strong>
                                </p>
                                
                                <h4>1 - EMPRESAS PROMOTORAS:</h4>
                                <p>1.1 - Empresa Mandat&aacute;ria:</p>
                                <p>
                                    Raz&atilde;o Social: VOLKSWAGEN DO BRASIL
                                    INDUSTRIA DE VEICULOS AUTOMOTORES LTDA
                                </p>
                                <p>
                                    Endere&ccedil;o: MARGINAL DA VIA ANCHIETA
                                    N&uacute;mero: S/N Complemento: KM 23,5 ALA
                                    17 Bairro: DEMARCHI Munic&iacute;pio: SAO
                                    BERNARDO DO CAMPO UF: SP CEP:09823-901
                                    CNPJ/MF n&ordm;: 59.104.422/0001-50
                                </p>
                                <h4>
                                    2 - MODALIDADE DA PROMO&Ccedil;&Atilde;O:
                                </h4>
                                <p>Assemelhada a Sorteio</p>
                                <h4>3 - &Aacute;REA DE ABRANG&Ecirc;NCIA:</h4>
                                <p>Todo o territ&oacute;rio nacional.</p>
                                <h4>
                                    4 - PER&Iacute;ODO DA
                                    PROMO&Ccedil;&Atilde;O:
                                </h4>
                                <p>25/10/2025 a 04/02/2026</p>
                                <h4>
                                    5 - PER&Iacute;ODO DE
                                    PARTICIPA&Ccedil;&Atilde;O:
                                </h4>
                                <p>25/10/2025 a 25/01/2026</p>
                                <p>
                                    6 - CRIT&Eacute;RIO DE
                                    PARTICIPA&Ccedil;&Atilde;O:
                                </p>
                                <strong>
                                    <u>DA PROMO&Ccedil;&Atilde;O</u>
                                </strong>
                                
                                
                                <p>
                                    6.1. A presente Promo&ccedil;&atilde;o
                                    &eacute; destinada &agrave;s pessoas
                                    f&iacute;sicas, maiores de 18 (dezoito) anos
                                    de idade, capazes, residentes e domiciliadas
                                    em territ&oacute;rio nacional, que sejam
                                    portadores da Carteira Nacional de
                                    Habilita&ccedil;&atilde;o (CNH)
                                    v&aacute;lida durante o Per&iacute;odo da
                                    Promo&ccedil;&atilde;o e que cumprirem com
                                    todas as regras deste Regulamento
                                    (&ldquo;Participante(s)&rdquo;).
                                </p>
                                <p>
                                    6.2. O per&iacute;odo de
                                    participa&ccedil;&atilde;o da presente
                                    Promo&ccedil;&atilde;o ter&aacute;
                                    in&iacute;cio &agrave;s 00h01 do dia 25 de
                                    outubro de 2025 e se encerrar&aacute;
                                    &agrave;s 23h59 do dia 25 de janeiro de 2026
                                    (&ldquo;Per&iacute;odo de
                                    Participa&ccedil;&atilde;o&rdquo;).
                                </p>
                                <strong>
                                    <u>DA MEC&Acirc;NICA</u>
                                </strong>
                                
                                <p>
                                    6.3. Para participar da
                                    Promo&ccedil;&atilde;o, durante o
                                    Per&iacute;odo de Participa&ccedil;&atilde;o
                                    indicado acima, o interessado dever&aacute;
                                    observar os seguintes passos:
                                </p>
                                <p>
                                    <strong>a. </strong>Dirigir-se a uma das
                                    concession&aacute;rias autorizadas
                                    Volkswagen indicadas no item a.1. abaixo;
                                </p>
                                <p>
                                    <strong>a.1. </strong>Os interessados
                                    poder&atilde;o consultar a lista de
                                    concession&aacute;rias autorizadas
                                    participantes da presente
                                    Promo&ccedil;&atilde;o atrav&eacute;s do
                                    link{" "}
                                    <a href="http://www.vw.com.br/pt/busca-de-concessionarias.html">
                                        https://www.vw.com.br/pt/busca-de-concessionarias.html
                                    </a>{" "}
                                    (&ldquo;Concession&aacute;ria(s)
                                    Autorizada(s)&rdquo;).
                                </p>
                                <p>
                                    <strong>b. </strong>Aceitar convite do
                                    consultor Volkswagen ou manifestar o seu
                                    interesse em realizar o Best Drive
                                    acompanhado por um consultor da
                                    Concession&aacute;ria Autorizada, isto
                                    &eacute;, realizar um test drive em um dos
                                    ve&iacute;culos dispon&iacute;veis nas
                                    Concession&aacute;rias Autorizadas
                                    (&ldquo;Best Drive&rdquo;);
                                </p>
                                <p>
                                    <strong>c. </strong>Apresentar a Carteira
                                    Nacional de Habilita&ccedil;&atilde;o (CNH)
                                    v&aacute;lida - em formato f&iacute;sico ou
                                    digital pelo aplicativo Carteira Digital de
                                    Tr&acirc;nsito
                                </p>
                                <p>
                                    - ao consultor da Concession&aacute;ria
                                    Autorizada, que realizar&aacute; o cadastro
                                    do Participante no Simple Drive, aplicativo
                                    de registro e controle digital de
                                    experimenta&ccedil;&otilde;es de
                                    ve&iacute;culos realizadas em
                                    Concession&aacute;rias Autorizadas
                                    (&ldquo;Aplicativo&rdquo;).
                                </p>
                                <p>
                                    <strong>c.1. </strong>Para
                                    realiza&ccedil;&atilde;o do cadastro, o
                                    Participante dever&aacute; assinar o Termo
                                    de Responsabilidade presente no aplicativo
                                    Simple Drive, declarando estar de acordo
                                    com: (i) o termo do test drive; (ii) o
                                    presente Regulamento; e (iii) o
                                    compartilhamento de seus dados com a
                                    Promotora, nos termos do Item 15.13 e
                                    seguintes e a consulta &agrave; base de
                                    dados pelo seu CPF. Neste momento, o
                                    consultor Volkswagen incluir&aacute; no
                                    Aplicativo uma foto da CNH apresentada pelo
                                    Participante.
                                </p>
                                <p>
                                    <strong>c.2. </strong>Ainda, para a
                                    conclus&atilde;o do Cadastro, o Participante
                                    dever&aacute; fornecer ao consultor
                                    Volkswagen os seguintes dados: nome
                                    completo, CPF, data de nascimento,
                                    n&uacute;mero de telefone, e-mail e marca e
                                    modelo do seu ve&iacute;culo atual
                                    (&ldquo;Cadastro&rdquo;);
                                </p>
                                <p>
                                    6.4. Fica desde j&aacute; estabelecido que,
                                    para que o Cadastro na presente
                                    Promo&ccedil;&atilde;o seja considerado
                                    v&aacute;lido, o Participante dever&aacute;:{" "}
                                    Confirmar se todos os dados coletados
                                    no Cadastro est&atilde;o corretos;
                                </p>
                                <p>
                                    Dar o seu aceite aos termos do
                                    presente Regulamento, formalizado
                                    atrav&eacute;s da assinatura digital do
                                    Participante no Aplicativo, que
                                </p>
                                <p>
                                    ser&aacute; disponibilizado pelo consultor
                                    Volkswagen;
                                </p>
                                <p>
                                    Responder &agrave; pesquisa de
                                    satisfa&ccedil;&atilde;o no Aplicativo
                                    ap&oacute;s a finaliza&ccedil;&atilde;o do
                                    Best Drive; e
                                </p>
                                <p>
                                    Responder se aceita ou n&atilde;o
                                    receber a proposta comercial referente ao
                                    ve&iacute;culo escolhido para a
                                    realiza&ccedil;&atilde;o do Best Drive.
                                </p>
                                <p>
                                    6.5. A realiza&ccedil;&atilde;o do test
                                    drive poder&aacute; estar condicionada
                                    &agrave; assinatura de documentos
                                    eventualmente solicitados pela
                                    Concession&aacute;ria Autorizada, nos termos
                                    de suas pol&iacute;ticas internas.
                                </p>
                            </div>
                            
                            <div>
                                <strong>
                                    <u>
                                        DOS CRIT&Eacute;RIOS T&Eacute;CNICOS
                                        PARA REGISTRO DO TEST DRIVE
                                        (&ldquo;Registro&rdquo;)
                                    </u>
                                </strong>
                                
                                <p>
                                    6.6. Para a realiza&ccedil;&atilde;o
                                    v&aacute;lida do Best Drive, o Participante
                                    dever&aacute; estar acompanhado de um
                                    consultor ou colaborador de uma
                                    Concession&aacute;ria Autorizada,
                                    respons&aacute;vel por iniciar e encerrar a
                                    fun&ccedil;&atilde;o de rastreamento de
                                    seguran&ccedil;a no Aplicativo Simple Drive.
                                </p>
                                <p>
                                    6.7. O correto funcionamento do rastreamento
                                    no Aplicativo depende das
                                    configura&ccedil;&otilde;es de
                                    localiza&ccedil;&atilde;o do aparelho
                                    celular utilizado pelo consultor/colaborador
                                    da Concession&aacute;ria Autorizada no
                                    momento da realiza&ccedil;&atilde;o do
                                    Cadastro do Participante na
                                    Promo&ccedil;&atilde;o. O dispositivo
                                    utilizado pelo consultor/colaborador da
                                    Concession&aacute;ria Autorizada
                                    dever&aacute; estar configurado para
                                    permitir o acesso de
                                    localiza&ccedil;&atilde;o exata e conceder
                                    permiss&atilde;o de uso ao Aplicativo da
                                    seguinte forma:
                                </p>
                                <p>

                                    <strong>Sistema iOS: </strong>
                                    op&ccedil;&atilde;o &ldquo;Permitir
                                    Sempre&rdquo;;
                                </p>
                                <p>
                                    &nbsp;<strong>Sistema Android</strong>:
                                    op&ccedil;&atilde;o &ldquo;Permitir o tempo
                                    todo&rdquo;.
                                </p>
                                <p>
                                    6.7.1. A fun&ccedil;&atilde;o de
                                    rastreamento &eacute; ativada no
                                    in&iacute;cio do test drive e desativada ao
                                    seu t&eacute;rmino, possibilitando a coleta
                                    autom&aacute;tica dos dados de
                                    dura&ccedil;&atilde;o (tempo) e
                                    dist&acirc;ncia percorrida pelo
                                    Participante, formando o respectivo
                                    Registro.
                                </p>
                                <p>
                                    6.8. O Participante compreende que
                                    caber&aacute; ao consultor da
                                    Concession&aacute;ria Autorizada realizar o
                                    Registro do test drive, devendo este zelar
                                    pelo uso adequado do Aplicativo e pelas
                                    informa&ccedil;&otilde;es coletadas durante
                                    a realiza&ccedil;&atilde;o do test drive,
                                    n&atilde;o podendo o Participante interferir
                                    no Registro, sob pena de
                                    invalida&ccedil;&atilde;o do test drive para
                                    fins de participa&ccedil;&atilde;o na
                                    Promo&ccedil;&atilde;o.
                                </p>
                                <p>
                                    6.9. Os Registros ser&atilde;o classificados
                                    como &ldquo;Confi&aacute;vel&rdquo; ou
                                    &ldquo;N&atilde;o Confi&aacute;vel&rdquo;,
                                    com base nas informa&ccedil;&otilde;es de
                                    dist&acirc;ncia e tempo registradas no
                                    Aplicativo. Para valida&ccedil;&atilde;o no
                                    sorteio ser&atilde;o aceito apenas os
                                    Registros confi&aacute;veis, observados os
                                    seguintes par&acirc;metros:
                                </p>
                                <p>
                                    <strong>
                                        Tempo de Dura&ccedil;&atilde;o do Best
                                        Drive
                                    </strong>
                                    : o tempo de dura&ccedil;&atilde;o
                                    dever&aacute; respeitar o limite
                                    m&aacute;ximo de 1 hora, 30 minutos e 99
                                    segundos; e
                                </p>
                                <p>
                                    <strong>
                                        Dist&acirc;ncia do Best Drive:{" "}
                                    </strong>
                                    a dist&acirc;ncia percorrida dever&aacute;
                                    respeitar o limite m&iacute;nimo de 1 (um)
                                    quil&ocirc;metro percorrido.
                                </p>
                                <p>
                                    6.10. Os Participantes que cumprirem todas
                                    as regras mencionadas nos itens acima
                                    ser&atilde;o eleg&iacute;veis ao recebimento
                                    de 01 (um) n&uacute;mero da sorte para
                                    concorrer &agrave;s premia&ccedil;&otilde;es
                                    ofertadas na presente
                                    Promo&ccedil;&atilde;o.
                                </p>
                                <p>
                                    6.11. Independentemente da quantidade de
                                    Best Drives realizados pelo Participante,
                                    seja em uma ou em diferentes
                                    Concession&aacute;rias Autorizadas, cada
                                    Participante far&aacute; jus ao recebimento
                                    de apenas 01 (um) n&uacute;mero da sorte,
                                    limitado a 01 (um) n&uacute;mero da sorte
                                    por CPF cadastrado na presente
                                    Promo&ccedil;&atilde;o.
                                </p>
                                <p>
                                    6.12.{" "}
                                    <u>
                                        Para fins de clareza, os pr&ecirc;mios
                                        ofertados na presente
                                        Promo&ccedil;&atilde;o ser&atilde;o
                                        aqueles descritos no item 9 deste
                                        Regulamento, sendo{" "}
                                    </u>
                                    certo{" "}
                                    <u>
                                        que cada Participante poder&aacute; ser
                                        contemplado com apenas 01 (um)
                                        pr&ecirc;mio no &acirc;mbito da presente
                                        Promo&ccedil;&atilde;o.
                                    </u>
                                </p>
                                <p>
                                    6.13. O Participante poder&aacute; consultar
                                    o seu n&uacute;mero da sorte atrav&eacute;s
                                    do site{" "}
                                    <a href="http://www.bestdrivepremiadovw.com.br/">
                                        www.bestdrivepremiadovw.com.br,
                                    </a>{" "}
                                    devendo preencher o CPF e e- mail informados
                                    no momento do Cadastro no Aplicativo Simple
                                    Drive realizado na Concession&aacute;ria
                                    Participante.
                                </p>
                                <h4>7 - QUANTIDADE DE S&Eacute;RIES:</h4>
                                <p>10</p>
                                <h4>
                                    8 - QUANTIDADE DE ELEMENTOS
                                    SORTE&Aacute;VEIS POR S&Eacute;RIE:
                                </h4>
                                <p>100.000</p>
                                <h4>
                                    9 - APURA&Ccedil;&Atilde;O E
                                    DESCRI&Ccedil;&Atilde;O DE PR&Ecirc;MIOS:
                                </h4>
                                <p>DATA: 04/02/2026 10:00</p>
                                <p>
                                    PER&Iacute;ODO DE PARTICIPA&Ccedil;&Atilde;O
                                    DA APURA&Ccedil;&Atilde;O: 25/10/2025 00:01
                                    a 25/01/2026 23:59 DATA DO SORTEIO DA
                                    LOTERIA FEDERAL: 31/01/2026
                                </p>
                                <p>
                                    ENDERE&Ccedil;O DA APURA&Ccedil;&Atilde;O:
                                    Estrada Marginal da Rodovia Anchieta
                                    N&Uacute;MERO: S/N COMPLEMENTO: KM 23,5
                                    BAIRRO: Demarchi MUNIC&Iacute;PIO:
                                    S&atilde;o Bernardo do Campo UF: SP CEP:
                                    09823-901
                                </p>
                                <p>
                                    LOCAL DA APURA&Ccedil;&Atilde;O: Sede da
                                    Promotora PR&Ecirc;MIOS
                                </p>
                                <table
                                    border="1"
                                    cellspacing="2"
                                    cellpadding="2"
                                >
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>
                                                    <strong>Quantidade</strong>
                                                </p>
                                            </td>
                                            <td width="40%">
                                                <p>
                                                    <strong>
                                                        Descri&ccedil;&atilde;o
                                                    </strong>
                                                </p>
                                            </td>
                                            <td>
                                                <p>
                                                    <strong>Valor R$</strong>
                                                </p>
                                            </td>
                                            <td>
                                                <p>
                                                    <strong>Valor</strong>{" "}
                                                    <strong>Total </strong>
                                                    <strong>R$</strong>
                                                </p>
                                            </td>
                                            <td>
                                                <p>
                                                    <strong>
                                                        S&eacute;rie{" "}
                                                    </strong>
                                                    <strong>Inicial</strong>
                                                </p>
                                            </td>
                                            <td>
                                                <p>
                                                    <strong>
                                                        S&eacute;rie{" "}
                                                    </strong>
                                                    <strong>Final</strong>
                                                </p>
                                            </td>
                                            <td>
                                                <p>
                                                    <strong>Ordem</strong>
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>10</p>
                                            </td>
                                            <td>
                                                <p>
                                                    01 (um) ve&iacute;culo
                                                    Volkswagen Tera MPI
                                                    (25/26/preto ninja/MPI sem
                                                    pacote adicional) para cada
                                                    contemplado
                                                </p>
                                            </td>
                                            <td>
                                                <p>105.890,00</p>
                                            </td>
                                            <td>
                                                <p>1.058.900,00</p>
                                            </td>
                                            <td>
                                                <p>0</p>
                                            </td>
                                            <td>
                                                <p>9</p>
                                            </td>
                                            <td>
                                                <p>1</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <h4>10 - PREMIA&Ccedil;&Atilde;O TOTAL:</h4>
                                <table
                                    border="1"
                                    cellspacing="4"
                                    cellpadding="4"
                                >
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>
                                                    <strong>
                                                        Quantidade Total de
                                                        Pr&ecirc;mios
                                                    </strong>
                                                </p>
                                            </td>
                                            <td>
                                                <p>
                                                    <strong>
                                                        Valor total da
                                                        Promo&ccedil;&atilde;o
                                                        R$
                                                    </strong>
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>10</p>
                                            </td>
                                            <td>
                                                <p>1.058.900,00</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p>11 - FORMA DE APURA&Ccedil;&Atilde;O:</p>
                            </div>
                            
                            <div>
                                <p>
                                    11.1. Ser&atilde;o emitidas 10 s&eacute;ries
                                    de n&uacute;meros da sorte, de 0 a 09,
                                    compostas, cada uma, por 100.000 (cem mil)
                                    n&uacute;meros da sorte, sendo que os
                                    n&uacute;meros da sorte ser&atilde;o
                                    compostos por 5 (cinco) algarismos,
                                    compreendidos entre 00.000 e 99.999, sendo
                                    que o Participante receber&aacute; os seus
                                    05 (cinco) algarismos correspondentes aos
                                    elementos sorte&aacute;veis e a
                                    indica&ccedil;&atilde;o de sua respectiva
                                    s&eacute;rie.
                                </p>
                                <p>
                                    11.2. Para a apura&ccedil;&atilde;o do
                                    n&uacute;mero da sorte do primeiro ganhador,
                                    ser&aacute; considerado o procedimento a
                                    seguir descrito: ser&aacute; o n&uacute;mero
                                    que corresponder &agrave;
                                    jun&ccedil;&atilde;o dos algarismos das
                                    unidades simples dos cinco primeiros
                                    pr&ecirc;mios (1&ordm; ao 5&ordm;
                                    pr&ecirc;mio) da Loteria Federal, lidos de
                                    cima para baixo.
                                </p>
                                <p>
                                    11.3. Para a apura&ccedil;&atilde;o da
                                    s&eacute;rie vencedora do Sorteio,
                                    ser&aacute; considerado o seguinte
                                    procedimento: ser&aacute; o n&uacute;mero
                                    que corresponder ao algarismo da dezena
                                    simples do primeiro pr&ecirc;mio (1&ordm;
                                    pr&ecirc;mio) da Loteria Federal, quando
                                    lidos de cima para baixo.
                                </p>
                                <p>
                                    Exemplo hipot&eacute;tico, considerando o
                                    resultado tamb&eacute;m hipot&eacute;tico
                                    abaixo - N&uacute;mero da Sorte premiado
                                    04.914 &ndash; S&eacute;rie 0: 1&ordm;
                                    Pr&ecirc;mio da Loteria Federal 9 7 3 0 0
                                </p>
                                <p>
                                    2&ordm; Pr&ecirc;mio da Loteria Federal 7 4
                                    2 2 4
                                </p>
                                <p>
                                    3&ordm; Pr&ecirc;mio da Loteria Federal 1 3
                                    5 7 9
                                </p>
                                <p>
                                    4&ordm; Pr&ecirc;mio da Loteria Federal 5 4
                                    3 2 1
                                </p>
                                <p>
                                    5&ordm; Pr&ecirc;mio da Loteria Federal 9 8
                                    5 2 4
                                </p>
                                <p>
                                    11.4. Para a apura&ccedil;&atilde;o dos
                                    demais N&uacute;meros da Sorte vencedores,
                                    ser&atilde;o considerados os N&uacute;meros
                                    da Sorte subsequentes, da mesma
                                    s&eacute;rie. Assim, o 2&ordm; N&uacute;mero
                                    da Sorte ser&aacute; o N&uacute;mero 04.915
                                    &ndash; S&eacute;rie 05, o 3&ordm;
                                    N&uacute;mero da Sorte ser&aacute; o
                                    N&uacute;mero 04.916 &ndash; S&eacute;rie
                                    05, o 4&ordm; N&uacute;mero da Sorte
                                    ser&aacute; o N&uacute;mero 04.917 &ndash;
                                    S&eacute;rie 05, e assim por diante.
                                </p>
                                <p>
                                    11.5. Caso o n&uacute;mero de s&eacute;rie
                                    encontrado seja superior &agrave; maior
                                    s&eacute;rie da apura&ccedil;&atilde;o,
                                    dever&aacute; ser subtra&iacute;da a
                                    quantidade total de s&eacute;ries da
                                    apura&ccedil;&atilde;o, do n&uacute;mero de
                                    s&eacute;rie encontrado, tantas vezes
                                    quantas forem necess&aacute;rias, at&eacute;
                                    que o n&uacute;mero obtido esteja dentro do
                                    intervalo de s&eacute;ries da
                                    apura&ccedil;&atilde;o.
                                </p>
                                <p>
                                    11.6. Ap&oacute;s a
                                    identifica&ccedil;&atilde;o da s&eacute;rie
                                    vencedora, ser&aacute; identificado o
                                    n&uacute;mero da sorte com base na
                                    extra&ccedil;&atilde;o da Loteria Federal,
                                    conforme os procedimentos acima descritos.
                                    Caso o resultado n&atilde;o tenha sido
                                    atribu&iacute;do a nenhum participante,
                                    ser&aacute; considerado vencedor o
                                    participante portador do N&uacute;mero da
                                    Sorte imediatamente subsequente, e assim por
                                    diante, at&eacute; o limite do n&uacute;mero
                                    99.999, na mesma s&eacute;rie. Se, ainda
                                    assim, n&atilde;o for poss&iacute;vel
                                    identificar um ganhador, deve-se retomar a
                                    apura&ccedil;&atilde;o a partir do
                                    n&uacute;mero 00.000 dentro da s&eacute;rie
                                    contemplada.
                                </p>
                                <p>
                                    11.7. Por fim, caso ainda n&atilde;o seja
                                    poss&iacute;vel identificar o contemplado, o
                                    mesmo procedimento supramencionado
                                    dever&aacute; ser observado, mas na
                                    s&eacute;rie imediatamente seguinte
                                    &agrave;quela sorteada, at&eacute; o limite
                                    da s&eacute;rie prevista em Regulamento, e
                                    ap&oacute;s, da s&eacute;rie imediatamente
                                    anterior, at&eacute; a s&eacute;rie 00.
                                </p>
                                <p>
                                    11.8. N&atilde;o ocorrendo
                                    extra&ccedil;&atilde;o da Loteria Federal na
                                    data prevista, o sorteio correspondente
                                    ser&aacute; adiado para a primeira
                                    extra&ccedil;&atilde;o subsequente que vier
                                    a ser realizada pela Caixa, sendo adiada
                                    tamb&eacute;m, proporcionalmente, a
                                    divulga&ccedil;&atilde;o dos vencedores.
                                    Todavia, caso o sorteio venha a ser
                                    antecipado pela Caixa, a Promotora
                                    poder&aacute;, a seu crit&eacute;rio,
                                    antecipar a data da apura&ccedil;&atilde;o,
                                    permanecendo inalteradas as datas de
                                    divulga&ccedil;&atilde;o dos vencedores.
                                </p>
                                <h4>
                                    12 - CRIT&Eacute;RIOS DE
                                    DESCLASSIFICA&Ccedil;&Atilde;O:
                                </h4>
                                <p>
                                    12.1. N&atilde;o poder&atilde;o participar
                                    da presente Promo&ccedil;&atilde;o:
                                </p>
                                <p>
                                    a) menores de 18 (dezoito) anos ou pessoas
                                    incapazes;
                                </p>
                                <p>b) pessoas jur&iacute;dicas;</p>
                                <p>
                                    c) funcion&aacute;rios da Promotora, seus
                                    c&ocirc;njuges, filhos, pais e demais
                                    familiares at&eacute; 3&deg; grau; e
                                </p>
                                <p>
                                    d) funcion&aacute;rios das ag&ecirc;ncias de
                                    propaganda e promo&ccedil;&atilde;o que
                                    mant&eacute;m contrato com a Promotora.
                                </p>
                                <p>
                                    12.2. A Promotora poder&aacute; providenciar
                                    consulta ao perfil dos Participantes por
                                    meio de seus bancos de dados, a fim de
                                    identificar qualquer rela&ccedil;&atilde;o
                                    dos Participantes com a Promotora ou com
                                    empresas a elas relacionadas, sendo certo
                                    que o Participante impedido ser&aacute;
                                    desclassificado.
                                </p>
                                <p>
                                    12.3. S&atilde;o condi&ccedil;&otilde;es que
                                    invalidam a participa&ccedil;&atilde;o na
                                    Promo&ccedil;&atilde;o:
                                    falsifica&ccedil;&atilde;o,
                                    adultera&ccedil;&atilde;o, omiss&atilde;o de
                                    informa&ccedil;&otilde;es ou fornecimento de
                                    informa&ccedil;&otilde;es parciais, falsas
                                    ou improcedentes, impossibilidade de
                                    identifica&ccedil;&atilde;o do Participante,
                                    qualquer tentativa de manipular, fraudar ou
                                    burlar os procedimentos de
                                    participa&ccedil;&atilde;o da
                                    Promo&ccedil;&atilde;o, aus&ecirc;ncia de
                                    apresenta&ccedil;&atilde;o de
                                    documenta&ccedil;&atilde;o solicitada pela
                                    Promotora.
                                </p>
                                <p>
                                    12.4. O Participante ser&aacute;
                                    exclu&iacute;do imediatamente da
                                    Promo&ccedil;&atilde;o em caso de fraude
                                    comprovada ou qualquer outra forma
                                    il&iacute;cita e/ou emprego de meios escusos
                                    para a obten&ccedil;&atilde;o de
                                    benef&iacute;cio/vantagem, ainda que nem
                                    todas as suas participa&ccedil;&otilde;es
                                    tenham valido ou se consumado nestas
                                    condi&ccedil;&otilde;es.
                                </p>
                                <h4>
                                    13 - FORMA DE DIVULGA&Ccedil;&Atilde;O DO
                                    RESULTADO:
                                </h4>
                                <p>
                                    13.1. Os vencedores da
                                    Promo&ccedil;&atilde;o ser&atilde;o
                                    divulgados no dia 13/02/2026 atrav&eacute;s
                                    do site{" "}
                                    <a href="http://www.bestdrivepremiadovw.com.br/">
                                        www.bestdrivepremiadovw.com.br
                                    </a>{" "}
                                    e do Instagram oficial da Volkswagen do
                                    Brasil, @vwbrasil{" "}
                                    <a href="http://www.instagram.com/vwbrasil/?hl=pt-br)">
                                        (https://www.instagram.com/vwbrasil/?hl=pt-br).
                                    </a>
                                </p>
                                <h4>14 - ENTREGA DOS PR&Ecirc;MIOS:</h4>
                                <p>
                                    14.1. A Promotora entrar&aacute; em contato
                                    com os Participantes contemplados por meio
                                    de e-mail e/ou WhatsApp, conforme os dados
                                    informados no momento do Cadastro.
                                </p>
                                <p>
                                    14.2. Ser&aacute; realizada a primeira
                                    tentativa de contato por e-mail, com prazo
                                    de at&eacute; 72 (setenta e duas) horas
                                    contadas do efetivo contato da Promotora
                                    para resposta do contemplado. Caso
                                    n&atilde;o haja retorno dentro desse prazo,
                                    ser&aacute; feita uma segunda tentativa por
                                    WhatsApp, por meio de mensagem de texto e
                                    liga&ccedil;&atilde;o.
                                </p>
                                <p>
                                    14.3. O Participante contemplado ter&aacute;
                                    o prazo de at&eacute; 72 (setenta e duas)
                                    horas, contado a partir do envio da mensagem
                                    pela Promotora no
                                </p>
                            </div>
                            
                            <div>
                                <p>
                                    WhatsApp, para responder e confirmar os
                                    dados necess&aacute;rios ao recebimento do
                                    pr&ecirc;mio.
                                </p>
                                <p>
                                    14.4. Caso o contemplado n&atilde;o responda
                                    &agrave; Promotora dentro dos prazos
                                    estabelecidos nas tentativas mencionadas,
                                    ser&aacute; aplicada a regra de
                                    desclassifica&ccedil;&atilde;o, conforme
                                    disposto neste Regulamento, e o pr&ecirc;mio
                                    ser&aacute; disponibilizado ao Participante
                                    portador do N&uacute;mero da Sorte
                                    subsequente. A Promotora poder&aacute;
                                    aplicar a presente regra quantas vezes forem
                                    necess&aacute;rias, at&eacute; que consiga
                                    distribuir a premia&ccedil;&atilde;o
                                    ofertada nesta Promo&ccedil;&atilde;o a um
                                    participante v&aacute;lido, conforme
                                    Crit&eacute;rios de
                                    Desclassifica&ccedil;&atilde;o do presente
                                    Regulamento.
                                </p>
                                <p>
                                    14.5. Os pr&ecirc;mios ser&atilde;o
                                    entregues na Concession&aacute;ria
                                    Autorizada mais pr&oacute;xima do
                                    endere&ccedil;o informado pelo Participante
                                    no momento do Cadastro em at&eacute; 30
                                    (trinta) dias contados da data da respectiva
                                    apura&ccedil;&atilde;o. Os contemplados
                                    dever&atilde;o assinar o respectivo Recibo
                                    de Entrega do Pr&ecirc;mio, quando da
                                    entrega do pr&ecirc;mio.
                                </p>
                                <p>
                                    14.6. Em nenhuma hip&oacute;tese, os
                                    pr&ecirc;mios poder&atilde;o ser convertidos
                                    em dinheiro, ou trocados por outro produto
                                    ou servi&ccedil;o.
                                </p>
                                <p>
                                    14.7. Na eventualidade do falecimento do
                                    ganhador, o pr&ecirc;mio ser&aacute;
                                    entregue ao seu inventariante, devendo o
                                    &uacute;ltimo comprovar tal
                                    condi&ccedil;&atilde;o.
                                </p>
                                <p>
                                    14.8. Os pr&ecirc;mios ser&atilde;o
                                    entregues livres e desembara&ccedil;ados de
                                    qualquer &ocirc;nus aos ganhadores.
                                </p>
                                <p>
                                    14.9. As despesas com Licenciamento Anual,
                                    Seguro Obrigat&oacute;rio, emplacamento e
                                    demais taxas at&eacute; a
                                    transfer&ecirc;ncia dos autom&oacute;veis
                                    aos seus contemplados ser&atilde;o arcadas
                                    pela Promotora. O IPVA ser&aacute; custeado
                                    pela Promotora apenas de forma proporcional
                                    aos meses remanescentes do exerc&iacute;cio
                                    fiscal vigente na data da entrega do
                                    pr&ecirc;mio, sendo de responsabilidade do
                                    contemplado o pagamento referente aos
                                    exerc&iacute;cios seguintes.
                                </p>
                                <h4>15 - DISPOSI&Ccedil;&Otilde;ES GERAIS:</h4>
                                <p>
                                    15.1. As d&uacute;vidas e
                                    controv&eacute;rsias oriundas de
                                    reclama&ccedil;&atilde;o dos participantes
                                    da Promo&ccedil;&atilde;o dever&atilde;o ser
                                    preliminarmente dirimidas pela Promotora, em
                                    at&eacute; 72 (setenta e duas) horas, por
                                    meio da Central de Relacionamento
                                    Volkswagen, acess&iacute;vel atrav&eacute;s
                                    do site <u>https://www.vw.</u>{" "}
                                    <u>
                                        com.br/pt/fale-conosco.html/
                                        layer/layers/fale_conosco/central-de-relacionamento/master.laye
                                    </u>
                                    r. Caso persistam, as mesmas dever&atilde;o
                                    ser submetidas &agrave; SPA e/ou aos
                                    &oacute;rg&atilde;os integrantes do Sistema
                                    Nacional de Defesa do Consumidor.
                                </p>
                                <p>
                                    15.2. A participa&ccedil;&atilde;o na
                                    Promo&ccedil;&atilde;o &eacute;
                                    volunt&aacute;ria e implicar&aacute; na
                                    aceita&ccedil;&atilde;o total e irrestrita
                                    de todos os itens deste Regulamento.
                                    N&atilde;o ter&atilde;o validade as
                                    participa&ccedil;&otilde;es que n&atilde;o
                                    preencherem as condi&ccedil;&otilde;es
                                    b&aacute;sicas da Promo&ccedil;&atilde;o
                                    previstas neste Regulamento.
                                </p>
                                <p>
                                    15.3. A participa&ccedil;&atilde;o na
                                    Promo&ccedil;&atilde;o implica tamb&eacute;m
                                    o conhecimento e aceita&ccedil;&atilde;o,
                                    pelo Participante, das
                                    caracter&iacute;sticas e dos limites da rede
                                    de Internet, especialmente no que se refere
                                    aos desempenhos t&eacute;cnicos, tempo de
                                    resposta para consultar, analisar ou
                                    transferir informa&ccedil;&otilde;es, riscos
                                    de interrup&ccedil;&atilde;o, riscos
                                    relacionados com a conex&atilde;o,
                                    aus&ecirc;ncia de prote&ccedil;&atilde;o de
                                    determinados dados contra eventuais coletas
                                    n&atilde;o autorizada e riscos de
                                    contamina&ccedil;&atilde;o por eventuais
                                    v&iacute;rus que circulam na rede de
                                    Internet. A Promotora n&atilde;o ser&aacute;
                                    considerada respons&aacute;vel pelas falhas
                                    que possam afetar a rede de Internet,
                                    qualquer problema de
                                    configura&ccedil;&atilde;o ou relacionado
                                    com um determinado navegador, problemas
                                    decorrentes do uso de aplicativos, dentre
                                    outros.
                                </p>
                                <p>
                                    15.4. A Promotora n&atilde;o se
                                    responsabiliza, em nenhuma hip&oacute;tese,
                                    pela funcionalidade dos servi&ccedil;os das
                                    operadoras de celular e/ou internet banda
                                    larga e/ou servidores de e-mail capazes de
                                    prejudicar a participa&ccedil;&atilde;o na
                                    presente Promo&ccedil;&atilde;o, sendo que o
                                    tempo de envio/upload de documentos,
                                    recebimento de mensagens e/ou
                                    aloca&ccedil;&atilde;o de mensagens em
                                    caixas de lixo eletr&ocirc;nico ou spam, bem
                                    como demais funcionalidades da
                                    opera&ccedil;&atilde;o ser&atilde;o de
                                    responsabilidade das respectivas operadoras.
                                </p>
                                <p>
                                    15.5. A Promotora n&atilde;o ser&aacute;
                                    respons&aacute;vel, ainda, por erro humano
                                    ou a&ccedil;&atilde;o deliberada de
                                    terceiros que possam interromper ou
                                    perturbar o normal funcionamento dos
                                    aplicativos envolvidos na presente
                                    Promo&ccedil;&atilde;o.
                                </p>
                                <p>
                                    15.6. Os contemplados concordam em
                                    autorizar, neste ato, gratuitamente, os
                                    direitos de uso do seu nome, imagem e som da
                                    voz &agrave; Promotora, em quaisquer
                                    m&iacute;dias f&iacute;sicas ou
                                    eletr&ocirc;nicas, tais como, mas n&atilde;o
                                    se restringindo a, DVD, revistas, jornais,
                                    website, newsletter, redes sociais, TV de
                                    qualquer esp&eacute;cie (aberta, fechada,
                                    Fast TV, etc.), r&aacute;dio, entre outras
                                    m&iacute;dias existentes ou que venham a ser
                                    criadas, sem restri&ccedil;&atilde;o de
                                    frequ&ecirc;ncia, para uso institucional ou
                                    comercial relacionado a esta
                                    Promo&ccedil;&atilde;o, pelo per&iacute;odo
                                    de 12 (doze) meses a contar do final da
                                    Promo&ccedil;&atilde;o, sem que isso
                                    implique qualquer tipo de pagamento ou
                                    &ocirc;nus pela Promotora.
                                </p>
                                <p>
                                    15.7. A Promotora processa e armazena os
                                    dados de tr&aacute;fego e de conex&atilde;o
                                    com os aplicativos envolvidos na presente
                                    Promo&ccedil;&atilde;o, principalmente, a
                                    identifica&ccedil;&atilde;o (endere&ccedil;o
                                    IP) do dispositivo utilizado pelo
                                    participante com o objetivo de gerar
                                    estat&iacute;sticas de acesso, garantir a
                                    seguran&ccedil;a da Promo&ccedil;&atilde;o,
                                    assim como verificar a correta
                                    participa&ccedil;&atilde;o, garantindo sua
                                    conformidade com este Regulamento, e na
                                    preven&ccedil;&atilde;o ou
                                    detec&ccedil;&atilde;o de acessos
                                    autom&aacute;ticos em seus sistemas, levando
                                    assim &agrave; exclus&atilde;o do
                                    Participante envolvido nesta atividade.
                                </p>
                                <p>
                                    15.8. Fica acordado que os dados existentes
                                    nos sistemas de informa&ccedil;&atilde;o da
                                    Promotora possuem valor probat&oacute;rio em
                                    rela&ccedil;&atilde;o &agrave; data e hora
                                    de conex&atilde;o, aos elementos de
                                    conex&atilde;o e das
                                    informa&ccedil;&otilde;es resultantes do
                                    processamento de dados relativo a esta
                                    Promo&ccedil;&atilde;o.
                                </p>
                                <p>
                                    15.9. A Promotora n&atilde;o ser&aacute;
                                    respons&aacute;vel por problemas, falhas ou
                                    funcionamento t&eacute;cnico, de qualquer
                                    tipo, em redes de computadores, servidores
                                    ou provedores, equipamentos de computadores,
                                    celulares, smartphones, tablets, hardware ou
                                    software, ou erro,
                                    interrup&ccedil;&atilde;o, defeito,
                                    interven&ccedil;&atilde;o, intrus&atilde;o
                                    externa e n&atilde;o autorizada, atraso ou
                                    falha em opera&ccedil;&otilde;es ou
                                    transmiss&otilde;es para o correto
                                    processamento de seus sistemas, incluindo,
                                    mas n&atilde;o se limitando,
                                    congestionamento na Internet, v&iacute;rus,
                                    falha de programa&ccedil;&atilde;o (bugs) ou
                                    viola&ccedil;&atilde;o por terceiros
                                    (hackers).
                                </p>
                                <p>
                                    15.10. A Promotora n&atilde;o se
                                    responsabiliza pela autenticidade,
                                    completude e veracidade dos dados fornecidos
                                    pelos participantes.
                                </p>
                                <p>
                                    15.11. A reprodu&ccedil;&atilde;o e
                                    representa&ccedil;&atilde;o de todos ou de
                                    parte dos sinais distintivos que fazem parte
                                    da Promo&ccedil;&atilde;o s&atilde;o
                                    estritamente proibidas, uma vez que
                                    s&atilde;o de titularidade da Promotora ou a
                                    ela est&atilde;o licenciados.
                                </p>
                                <p>
                                    15.12. A Promotora poder&aacute; auditar o
                                    andamento e/ou o resultado final da
                                    Promo&ccedil;&atilde;o, a qualquer tempo e a
                                    seu exclusivo crit&eacute;rio, de forma a
                                    garantir a lisura e igualdade de
                                    participa&ccedil;&atilde;o de todos os
                                    interessados.
                                </p>
                                <p>
                                    <u>
                                        PRIVACIDADE E PROTE&Ccedil;&Atilde;O DE
                                        DADOS
                                    </u>
                                </p>
                                <p>
                                    15.13. Ao confirmar o cadastro na
                                    Promo&ccedil;&atilde;o, o Participante
                                    reconhece que a Promotora utilizar&aacute;,
                                    sem qualquer &ocirc;nus, seus dados pessoais
                                    fornecidos no momento do cadastro para as
                                    finalidades abaixo relacionadas:
                                </p>
                            </div>
                            
                            <div>
                                <p>
                                    <u>FINALIDADES:</u>
                                </p>
                                <p>
                                    <img
                                        src="Regulamento%20Autorizado_VW%20Best%20Drive%20Premiado%20(ID%20131000)%5b2%5d_arquivos/image004.gif"
                                        alt=""
                                        width="4"
                                        height="4"
                                        border="0"
                                    />
                                    &nbsp;Verifica&ccedil;&atilde;o da
                                    compatibilidade do perfil do participante
                                    com os crit&eacute;rios de
                                    participa&ccedil;&atilde;o;{" "}
                                    <img
                                        src="Regulamento%20Autorizado_VW%20Best%20Drive%20Premiado%20(ID%20131000)%5b2%5d_arquivos/image005.gif"
                                        alt=""
                                        width="4"
                                        height="4"
                                        border="0"
                                    />
                                    &nbsp;Viabiliza&ccedil;&atilde;o da
                                    apura&ccedil;&atilde;o dos ganhadores da
                                    Promo&ccedil;&atilde;o;
                                </p>
                                <p>
                                    <img
                                        src="Regulamento%20Autorizado_VW%20Best%20Drive%20Premiado%20(ID%20131000)%5b2%5d_arquivos/image002.gif"
                                        alt=""
                                        width="4"
                                        height="4"
                                        border="0"
                                    />
                                    &nbsp;Envio de comunica&ccedil;&otilde;es
                                    gerais referentes &agrave;
                                    Promo&ccedil;&atilde;o;
                                </p>
                                <p>
                                    <img
                                        src="Regulamento%20Autorizado_VW%20Best%20Drive%20Premiado%20(ID%20131000)%5b2%5d_arquivos/image003.gif"
                                        alt=""
                                        width="4"
                                        height="4"
                                        border="0"
                                    />
                                    &nbsp;Outras atividades, ainda que
                                    n&atilde;o expressamente informadas, mas
                                    intr&iacute;nsecas e estritamente
                                    necess&aacute;rias &agrave;
                                    realiza&ccedil;&atilde;o da
                                    Promo&ccedil;&atilde;o; e{" "}
                                    <img
                                        src="Regulamento%20Autorizado_VW%20Best%20Drive%20Premiado%20(ID%20131000)%5b2%5d_arquivos/image004.gif"
                                        alt=""
                                        width="4"
                                        height="4"
                                        border="0"
                                    />
                                    &nbsp;Forma&ccedil;&atilde;o de cadastro
                                    para refor&ccedil;o de m&iacute;dia
                                    publicit&aacute;ria e demais
                                    divulga&ccedil;&otilde;es da Promotora, nos
                                    limites do C&oacute;digo de Defesa do
                                </p>
                                <p>Consumidor.</p>
                                <p>
                                    15.14. A Promotora armazenar&aacute; os
                                    dados pessoais coletados em ambiente seguro,
                                    observado o estado da t&eacute;cnica
                                    dispon&iacute;vel, e somente
                                    permitir&aacute; que sejam acessados por
                                    pessoas qualificadas, que necessitem ter
                                    acesso aos dados pessoais para o cumprimento
                                    das finalidades aqui previstas, e
                                    previamente autorizadas pela Promotora. A
                                    Promotora assegura que todos esses
                                    indiv&iacute;duos est&atilde;o sujeitos a
                                    obriga&ccedil;&otilde;es de sigilo e
                                    confidencialidade.
                                </p>
                                <p>
                                    15.15. Para as finalidades previstas acima,
                                    a Promotora poder&aacute; compartilhar seus
                                    dados pessoais no &acirc;mbito de seu grupo
                                    econ&ocirc;mico, bem como com terceiros que
                                    lhe prestem servi&ccedil;os relacionados
                                    &agrave; Promo&ccedil;&atilde;o, nas
                                    seguintes circunst&acirc;ncias:
                                </p>
                                <p>
                                    a. Para empresa que lhe presta
                                    servi&ccedil;os de desenvolvimento e suporte
                                    dos hotsites e aplicativos envolvidos nesta
                                    Promo&ccedil;&atilde;o, para o fim
                                    espec&iacute;fico de administr&aacute;-los e
                                    manter sua qualidade e seguran&ccedil;a;
                                </p>
                                <p>
                                    b. Para a ag&ecirc;ncia de publicidade, para
                                    o fim espec&iacute;fico de auxiliar na
                                    administra&ccedil;&atilde;o e gerenciamento
                                    da Promo&ccedil;&atilde;o;
                                </p>
                                <p>
                                    c. Para a empresa que lhe presta
                                    servi&ccedil;os relacionados &agrave;
                                    viabiliza&ccedil;&atilde;o da mec&acirc;nica
                                    da Promo&ccedil;&atilde;o;
                                </p>
                                <p>
                                    d. Para fins de processos judiciais e
                                    seguran&ccedil;a: caso a Promotora seja
                                    obrigada por lei a divulgar seus dados
                                    pessoais, ou, se em seu julgamento de
                                    boa-f&eacute;, essa a&ccedil;&atilde;o for
                                    razoavelmente necess&aacute;ria para cumprir
                                    os processos legais, para responder a
                                    quaisquer reivindica&ccedil;&otilde;es, ou
                                    para proteger a seguran&ccedil;a ou os
                                    direitos da Promotora;
                                </p>
                                <p>
                                    e. Em caso de incorpora&ccedil;&atilde;o ou
                                    aquisi&ccedil;&atilde;o de toda ou parte da
                                    Promotora por uma outra companhia, ou caso a
                                    Promotora realize a venda de toda ou uma
                                    parte de seu neg&oacute;cio, a adquirente
                                    que ter&aacute; acesso &agrave;s
                                    informa&ccedil;&otilde;es mantidas por esse
                                    neg&oacute;cio da Promotora, as quais
                                    poderiam incluir dados pessoais, sujeito
                                    &agrave; lei aplic&aacute;vel. Do mesmo
                                    modo, os dados pessoais poder&atilde;o ser
                                    transferidos como parte de uma
                                    reestrutura&ccedil;&atilde;o corporativa,
                                    processo de insolv&ecirc;ncia ou outro
                                    evento similar, se permitido e feito de
                                    acordo com a lei aplic&aacute;vel.
                                </p>
                                <p>
                                    15.16. Quaisquer terceiros com os quais a
                                    Promotora compartilhe seus dados pessoais
                                    estar&atilde;o vinculados a r&iacute;gidas
                                    regras de privacidade,
                                    prote&ccedil;&atilde;o e seguran&ccedil;a
                                    para o tratamento de seus dados pessoais.
                                    N&atilde;o permitimos que quaisquer
                                    terceiros usem os dados de qualquer outra
                                    maneira que n&atilde;o esteja de acordo com
                                    nossas instru&ccedil;&otilde;es expressas e
                                    espec&iacute;ficas, e com as leis de
                                    privacidade e prote&ccedil;&atilde;o de
                                    dados pessoais aplic&aacute;veis. A
                                    Promotora assegura que as suas
                                    informa&ccedil;&otilde;es nunca ser&atilde;o
                                    compartilhadas com nenhum outro terceiro,
                                    que n&atilde;o esteja aqui especificado, ou
                                    usadas para finalidades diversas daquelas
                                    para as quais foram coletadas, tamb&eacute;m
                                    expressamente especificadas neste
                                    Regulamento.
                                </p>
                                <p>
                                    15.17. A PROMOTORA &Eacute; EXPRESSAMENTE
                                    VEDADA DE COMERCIALIZAR OU CEDER OS DADOS
                                    PESSOAIS COLETADOS E TRATADOS EM
                                    DECORR&Ecirc;NCIA DESSA
                                    PROMO&Ccedil;&Atilde;O, CONFORME ARTIGO 12
                                    DA PORTARIA SEAE/ME N&ordm; 7.638/2022.
                                </p>
                                <p>
                                    15.18. Todas as demais
                                    condi&ccedil;&otilde;es relacionadas
                                    &agrave; prote&ccedil;&atilde;o de seus
                                    dados pessoais est&atilde;o previstas na
                                    Pol&iacute;tica de Privacidade da Promotora,
                                    dispon&iacute;vel no link <u>https://</u>
                                    <a href="http://www.vw.com.br/pt/volkswagen/informacoes-legais/politica-de-privacidade.html">
                                        www.vw.com.br/pt/volkswagen/informacoes-legais/politica-de-privacidade.html.
                                    </a>{" "}
                                    Na eventualidade de diverg&ecirc;ncias entre
                                    as disposi&ccedil;&otilde;es sobre
                                    prote&ccedil;&atilde;o de dados acima e
                                    conte&uacute;do da Pol&iacute;tica de
                                    Privacidade, as disposi&ccedil;&otilde;es
                                    acima dever&atilde;o prevalecer para a
                                    presente Promo&ccedil;&atilde;o.
                                </p>
                                <p>
                                    15.19. A Promotora dever&aacute; encaminhar
                                    &agrave; SPA a Lista de Participantes,
                                    anexando na aba "Apura&ccedil;&otilde;es" do
                                    sistema SCPC, os nomes e n&uacute;meros da
                                    sorte distribu&iacute;dos, ap&oacute;s o
                                    t&eacute;rmino do Per&iacute;odo de
                                    Participa&ccedil;&atilde;o e antes da
                                    extra&ccedil;&atilde;o da Loteria Federal.
                                </p>
                                <h4>16 - TERMO DE RESPONSABILIDADE</h4>
                                <p>
                                    Poder&aacute; participar da
                                    promo&ccedil;&atilde;o qualquer consumidor
                                    que preencha os requisitos estipulados no
                                    regulamento da campanha autorizada; Os
                                    pr&ecirc;mios n&atilde;o poder&atilde;o ser
                                    convertidos em dinheiro;
                                </p>
                                <p>
                                    &Eacute; vedada a apura&ccedil;&atilde;o por
                                    meio eletr&ocirc;nico;
                                </p>
                                <p>
                                    Os pr&ecirc;mios ser&atilde;o entregues em
                                    at&eacute; 30 dias da data da
                                    apura&ccedil;&atilde;o/sorteio, sem qualquer
                                    &ocirc;nus aos contemplados
                                </p>
                                <p>
                                    Quando o pr&ecirc;mio sorteado, ganho em
                                    concurso ou conferido mediante vale-brinde,
                                    n&atilde;o for reclamado no prazo de cento e
                                    oitenta (180) dias, contados,
                                    respectivamente, da data do sorteio, da
                                    apura&ccedil;&atilde;o do resultado do
                                    concurso ou do t&eacute;rmino do prazo da
                                    promo&ccedil;&atilde;o, caducar&aacute; o
                                    direito do respectivo titular e o valor
                                    correspondente ser&aacute; recolhido, pela
                                    empresa autorizada, ao Tesouro Nacional,
                                    como renda da Uni&atilde;o, no prazo de
                                    quarenta e cinco (45) dias;
                                </p>
                                <p>
                                    Em caso de promo&ccedil;&otilde;es com
                                    participa&ccedil;&atilde;o de menor de
                                    idade, sendo este contemplado,
                                    dever&aacute;, no ato da entrega do
                                    pr&ecirc;mio, ser representado por seu
                                    respons&aacute;vel legal; &agrave;
                                    exce&ccedil;&atilde;o das
                                    promo&ccedil;&otilde;es comerciais
                                    realizadas por concession&aacute;ria ou
                                    permission&aacute;ria de servi&ccedil;o de
                                    radiodifus&atilde;o, nos termos do artigo
                                    1&ordm;-A, &sect; 3&ordm;, da Lei 5.768, de
                                    20 de dezembro de 1971;
                                </p>
                                <p>
                                    A divulga&ccedil;&atilde;o da imagem dos
                                    contemplados poder&aacute; ser feita
                                    at&eacute; um ano ap&oacute;s a
                                    apura&ccedil;&atilde;o da
                                    promo&ccedil;&atilde;o comercial;
                                </p>
                                <p>
                                    As d&uacute;vidas e controv&eacute;rsias
                                    oriundas de reclama&ccedil;&otilde;es dos
                                    participantes ser&atilde;o, primeiramente,
                                    dirimidas pela promotora, persistindo-as,
                                    estas dever&atilde;o ser submetidas &agrave;
                                    SPA/MF.
                                </p>
                                <p>
                                    Os &oacute;rg&atilde;os locais de defesa do
                                    consumidor receber&atilde;o as
                                    reclama&ccedil;&otilde;es devidamente
                                    fundamentadas;
                                </p>
                                <p>
                                    A presta&ccedil;&atilde;o de contas
                                    dever&aacute; ser realizada no prazo
                                    m&aacute;ximo de trinta dias ap&oacute;s a
                                    data de prescri&ccedil;&atilde;o dos
                                    pr&ecirc;mios sob pena de descumprimento do
                                    plano de distribui&ccedil;&atilde;o de
                                    pr&ecirc;mios;
                                </p>
                                <p>
                                    O regulamento dever&aacute; ser afixado em
                                    lugar de ampla visibilidade e se apresentar
                                    em tamanho e em grafia que viabilizem a
                                    compreens&atilde;o e
                                    visualiza&ccedil;&atilde;o por parte do
                                    consumidor participante da
                                    promo&ccedil;&atilde;o comercial;
                                </p>
                            </div>
                            
                            <div>
                                <p>
                                    Al&eacute;m dos termos acima, a
                                    promo&ccedil;&atilde;o comercial
                                    dever&aacute; obedecer &agrave;s
                                    condi&ccedil;&otilde;es previstas na Lei
                                    n&ordm; 5.768, de 1971, no Decreto n&ordm;
                                    70.951, de 1972, Portaria SEAE n&ordm;
                                    7.638, de 2022, Portaria MF n&ordm; 67, de
                                    2017, Portaria SECAP n&ordm; 20.749 de 2000,
                                    e em atos que as complementarem.
                                </p>
                                <p>
                                    Para as modalidades "Sorteio" e "Assemelhada
                                    a Sorteio" a empresa dever&aacute; anexar a
                                    Lista de Participantes na aba
                                    "Apura&ccedil;&otilde;es", contendo nomes e
                                    n&uacute;meros da sorte distribu&iacute;dos,
                                    ap&oacute;s o t&eacute;rmino de cada
                                    per&iacute;odo de participa&ccedil;&atilde;o
                                    e antes da extra&ccedil;&atilde;o da
                                    Loteria. O arquivo dever&aacute; ser no
                                    formato .csv, .xls ou .zip e cada arquivo
                                    poder&aacute; ter at&eacute; 250 MB.
                                </p>
                                <p>
                                    A infring&ecirc;ncia &agrave;s
                                    cl&aacute;usulas do Termo de
                                    Responsabilidade e do Regulamento constituem
                                    descumprimento do plano de
                                    opera&ccedil;&atilde;o e ensejam as
                                    penalidade previstas no artigo 13 da Lei
                                    n&ordm;. 5.768, de 1971.
                                </p>
                                <h4>DA PRESTA&Ccedil;&Atilde;O DE CONTAS</h4>
                                <p>
                                    A presta&ccedil;&atilde;o de contas
                                    dever&aacute; ser realizada at&eacute; a
                                    data constante no cabe&ccedil;alho da
                                    promo&ccedil;&atilde;o no SCPC, conforme as
                                    regras estabelecidas na Portaria SEAE
                                    n&ordm; 7.638, de 18 de outubro de 2022. O
                                    vencimento do prazo para a
                                    presta&ccedil;&atilde;o de contas constitui
                                    em mora &agrave;s empresas promotoras. A
                                    n&atilde;o realiza&ccedil;&atilde;o da
                                    presta&ccedil;&atilde;o de contas at&eacute;
                                    a data de seu vencimento ensejar&aacute; a
                                    aplica&ccedil;&atilde;o de multa de 100%
                                    (cem por cento) incidente sobre a soma dos
                                    valores dos bens prometidos a t&iacute;tulo
                                    de premia&ccedil;&atilde;o e a
                                    proibi&ccedil;&atilde;o de realizar as
                                    opera&ccedil;&otilde;es de
                                    distribui&ccedil;&atilde;o gratuita de
                                    pr&ecirc;mios a t&iacute;tulo de propaganda,
                                    durante o prazo de 2 (dois) anos, contados
                                    da data limite da presta&ccedil;&atilde;o de
                                    contas, nos termos do art. 13 da Lei n&ordm;
                                    5.768, de 20 de dezembro de 1971. A
                                    fixa&ccedil;&atilde;o da multa poder&aacute;
                                    ser revista em grau de recurso
                                    administrativo, a ser apresentado conforme o
                                    art. 56 da Lei n&ordm; 9.784, de 29 de
                                    janeiro de 1999.
                                </p>
                                <p>
                                    <br />
                                    Documento assinado eletronicamente por MARCO
                                    ANTONIO DE GOUVEA, T&eacute;cnico, em
                                    20/10/2025 &agrave;s 14:58, conforme
                                    hor&aacute;rio oficial de Bras&iacute;lia,
                                    com fundamento no art. 6o, &sect; 1o, do
                                    Decreto no 8.539, de 8 de outubro de 2015.
                                </p>
                                <p>
                                    <br />A autenticidade deste documento pode
                                    ser conferida no site:
                                    https://scpc.seae.fazenda.gov.br/scpc/consulta_codigo_autenticacao.jsf,
                                    informando o c&oacute;digo verificador
                                    MRH.FEQ.SMK
                                </p>
                            </div>
                        </StyleRegulamentoContent>
                    </StyleRegulamentoWrapper>
                    <div>
                        <p>
                            Período de participação: de 25/10/2025 a 25/01/2026.
                            Serão considerados válidos apenas os test drives
                            realizados nas concessionárias participantes e que
                            atendam aos parâmetros descritos no regulamento,
                            limitado a um prêmio por CPF. Certificado de
                            autorização N.° 04.045460/2025.
                        </p>
                    </div>
                </StyleContentWrapper>
            </StyleWrapper>
        </>
    );
};
